// extracted by mini-css-extract-plugin
export default {"promo_banner":"PromoBanner_promo_banner__pzueI"};